import { render } from "./DropboxInfo.vue?vue&type=template&id=f209b650&scoped=true"
import script from "./DropboxInfo.vue?vue&type=script&lang=js"
export * from "./DropboxInfo.vue?vue&type=script&lang=js"

import "./DropboxInfo.vue?vue&type=style&index=0&id=f209b650&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f209b650"]])

export default __exports__